import React, { useEffect, useState } from "react";
import { getAllSubsites, allSubsites, subsiteTotalCount } from '../../reducers/subsite';
import {reloadUser} from '../../reducers/auth';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import MSMPagination from '../MSMPagination';
import CreateSubsiteModal from '../modals/CreateSubsiteModal';
import Button from "react-bootstrap/Button";
import { useNavigate } from 'react-router-dom';
import { Diagram2 } from 'react-bootstrap-icons';

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const AdminSubsites = () => {
  const subsites = useSelector(allSubsites);
  const subsiteStatus = useSelector(state => state.subsite.status);
  const subsiteTotal = useSelector(subsiteTotalCount);
  const [ modalShow, setModalShow ] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [range, setRange] = useState([1,10]);
  const [reload, setReload] = useState(false);
  const [resetPagination, setResetPagination] = useState(false);
  let perPage = 10;
  const [currentSubsite, setCurrentSubsite] = useState({});

  useEffect(() => {
    if (subsiteStatus === 'idle') {
        console.log("GET ALL SUBSITES");
      dispatch(getAllSubsites(range));
    }
  }, [subsiteStatus, dispatch]);
  
  useEffect(() => {
    dispatch(getAllSubsites(range));
    dispatch(reloadUser());
  }, [range, reload, dispatch]);

  let content = "";

  console.log("SUBSITE STATUS" , subsiteStatus);

  if (subsiteStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (subsiteStatus === 'succeeded') {
    console.log("SUBSITE" , subsites[0]);

    content = subsites.map(subsite => (
      <div className="user-list-item" onClick={() => {setCurrentSubsite(subsite); setModalShow(true);}}>
        <div style={{flex: 1, backgroundColor: "#000000", height: 100, alignContent: "center", textAlign: "center", margin: 10}}>
          <img width={90} src={`${BACKEND_URL}/uploads/subsites/${subsite.logoFilename}`} />
        </div>
        <div className="details">
          <span className="title">Subsite:</span> {subsite.subsiteName}<br/>
          <span className="title">Abbr:</span> {subsite.abbreviation}<br/>
          <span className="title">Active:</span> {subsite.active ? "true" : "false"}<br/>
          <span className="title">POC:</span> {subsite.internalPOCs}
        </div>
      </div>
    ));    
  } else if (subsiteStatus === 'failed') {
    content = <div>error</div>
  }

  const reloadData = (range) => {
    setRange(range);
  }
  
  const closeModal = (status) => {
    setModalShow(false);
    if(status) setReload(!reload);
  }

  const showModal = () => {
    setModalShow(true);
  }
  return (
    <div className="page_container">
       <Button onClick={() => {setCurrentSubsite({}); showModal()}}><Diagram2/ > Add Subsite</Button>
      <MSMPagination reload={reloadData} perPage={perPage} total={subsiteTotal} reset={resetPagination} />
      {content}
      {modalShow && <CreateSubsiteModal show={modalShow} closeModal={closeModal} subsite={currentSubsite}/>}
    </div>
  );
};
export default AdminSubsites;

